import { render, staticRenderFns } from "./dui-store-value.vue?vue&type=template&id=68510599&scoped=true&"
import script from "./dui-store-value.vue?vue&type=script&lang=js&"
export * from "./dui-store-value.vue?vue&type=script&lang=js&"
import style0 from "./dui-store-value.vue?vue&type=style&index=0&id=68510599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68510599",
  null
  
)

export default component.exports